"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.integerDescription = void 0;
const isInteger_1 = __importDefault(require("lodash/isInteger"));
const InvalidResult_1 = __importDefault(require("./InvalidResult"));
const Number_1 = require("./Number");
const ValidationResult_1 = require("./ValidationResult");
exports.integerDescription = {
    userFacingTitle: 'integer',
    userFacingValue: String,
    validate: value => (0, ValidationResult_1.validationResultTry)(Number_1.defaultNumberDescription.validate(value), number => {
        if (!(0, isInteger_1.default)(number)) {
            return new InvalidResult_1.default(`Not an integer: ${value}`);
        }
        return number;
    }),
};
